import { createSlice } from '@reduxjs/toolkit';

interface InvoiceApiError {
  message: string;
  category: string;
}

const initialState = {
  isPaymentMade: false,
  showInvoicePaymentProcessingFailure: null as InvoiceApiError | null,
};

export const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setPaymentAction: (state, action) => {
      state.isPaymentMade = action.payload;
    },
    setInvoicePaymentProcessingFailure: (state, action) => {
      state.showInvoicePaymentProcessingFailure = action.payload;
    },
  },
});

/** Action creators are generated for each case reducer function */
export const { setPaymentAction, setInvoicePaymentProcessingFailure } = invoiceSlice.actions;

export default invoiceSlice.reducer;
